/**
 * Verify OTP page - same layout as Login/Signup (header, main, footer).
 */

import React from 'react';
import OTPVerification from '../../components/auth/OTPVerification';
import { PublicHeader, PublicFooter } from '../../components/public';

const VerifyOTP = () => (
  <div className="auth-page-layout">
    <PublicHeader />
    <main className="auth-page-main">
      <OTPVerification />
    </main>
    <PublicFooter />
  </div>
);

export default VerifyOTP;
